<script setup lang="ts">
defineProps<{ info: string }>()
</script>

<template>
  <div class="popup">
    <p>{{ info }}</p>
  </div>
</template>

<style lang="scss">
.tooltip {
  .popup {
    width: 200px;
    text-align: center;
    border-radius: 16px !important;
    background: #fafaf9;
    padding: 12px;

    &:after {
      content: '';
      height: 100%;
      width: 100%;
      border-radius: 16px;
      position: absolute;
      top: 0;
      left: 0;
      box-shadow: 0 1px 14px rgba(0, 0, 0, 0.2);
    }
  }

  #arrow {
    position: absolute;
    width: 15px;
    height: 15px;
    background: #fafaf9;
    transform: rotate(45deg);
  }
}
</style>
